function openEgiftModal() {
  const egift_modal = document.querySelector(".js-ci-egift-modal");
  if (egift_modal != null) {
    document.body.appendChild(egift_modal);
    egift_modal.classList.add("egift-about-open");
    document.body.classList.add("no-scroll");
  }
  const egift_modal_bg = document.querySelector(".js-ci-egift-modal-bg");
  if (egift_modal_bg != null) {
    document.body.appendChild(egift_modal_bg);
    egift_modal_bg.classList.add("egift-about-open");
    egift_modal_bg.addEventListener("click", () => {
      egift_modal.classList.remove("egift-about-open");
      egift_modal_bg.classList.remove("egift-about-open");
      document.body.classList.remove("no-scroll");
    });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const egift_modal = document.querySelector(".js-ci-egift-modal");
  const egift_modal_bg = document.querySelector(".js-ci-egift-modal-bg");
  if (egift_modal_bg != null) {
    egift_modal_bg.addEventListener("click", () => {
      egift_modal.classList.remove("egift-about-open");
      egift_modal_bg.classList.remove("egift-about-open");
      document.body.classList.remove("no-scroll");
    });
  }
  const egift_modal_close = document.querySelector(".anygift-about-modal-close-icon");
  if (egift_modal_close != null) {
    egift_modal_close.addEventListener("click", () => {
      egift_modal.classList.remove("egift-about-open");
      egift_modal_bg.classList.remove("egift-about-open");
      document.body.classList.remove("no-scroll");
    });
  }
  const egift_modal_close_button = document.querySelector(".anygift-about-modal-close-button");
  if (egift_modal_close_button != null) {
    egift_modal_close_button.addEventListener("click", () => {
      egift_modal.classList.remove("egift-about-open");
      egift_modal_bg.classList.remove("egift-about-open");
      document.body.classList.remove("no-scroll");
    });
  }
});
